__webpack_require__.p = "/nupoor_portfolio/";